const ScorecardModal = ({ open, onClose, playerVs, winner, type, onUpdateScore, onVerifyScore, onWalkoverChange,}) => {
    if (!open || !playerVs) return null;

    const isVerified = playerVs.IsScoreVerified === "Y";
    const isSubmitted = playerVs.IsCardSubmitted === "Y";

    const walkoverSide = winner?.IsWalkOver === "Y"
    ? (winner.User1ID === playerVs.User1ID ? "LHS" : "RHS")
    : null;

    return (
    <>
        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} onClick={onClose} />
        <div className="modal fade show" style={{ display: "block" , zIndex: 1050 }} tabIndex="-1" role="dialog" onClick={e=> e.stopPropagation()}
            >
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">

                    {/* Header */}
                    <div className="modal-header">
                        <h5 className="modal-title">Match Play Scorecard</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    {/* Body */}
                    <div className="modal-body">
                        <div style={{ display: "flex" }}>

                            {/* ── LHS ── */}
                            <div className="col-6">
                                {type === "Doubles" && (
                                <h5 className="margin-b15"><strong>Team 1</strong></h5>
                                )}
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-4">Player 1 <span className="text-danger">*</span></label>
                                    <div className="col-lg-6">
                                        <input type="text" className="form-control" value={playerVs.User1Name || "" } disabled />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-4">Handicap</label>
                                    <div className="col-lg-6">
                                        <input type="text" className="form-control" value={playerVs.User1Handicap ?? "" } readOnly />
                                    </div>
                                </div>
                                {type === "Doubles" && (
                                <>
                                    <hr />
                                    <div className="form-group row" style={{ marginTop: "1rem" }}>
                                        <label className="col-form-label col-lg-4">Player 2 <span className="text-danger">*</span></label>
                                        <div className="col-lg-6">
                                            <input type="text" className="form-control" value={playerVs.User2Name || "" } disabled />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-4">Handicap</label>
                                        <div className="col-lg-6">
                                            <input type="text" className="form-control" value={playerVs.User2Handicap ?? "" } readOnly />
                                        </div>
                                    </div>
                                </>
                                )}
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-4">Walkover Received</label>
                                    <div className="col-lg-6 d-flex align-items-center" style={{ minHeight: 38 }}>
                                        <span className="kt-switch kt-switch--icon">
                                            <label>
                                                <input type="checkbox" checked={walkoverSide==="LHS" } disabled={isVerified} onChange={e=> onWalkoverChange("LHS", e.target.checked)}
                                                />
                                                <span />
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Divider */}
                            <div style={{ width: 1, backgroundColor: "#eee" , margin: "0 16px" , flexShrink: 0 }} />

                            {/* ── RHS ── */}
                            <div className="col-6">
                                {type === "Doubles" && (
                                <h5 className="margin-b15"><strong>Team 2</strong></h5>
                                )}
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-4">
                                        {type === "Doubles" ? "Player 1" : "Player 2"} <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-lg-6">
                                        <input type="text" className="form-control" value={(type==="Singles" ? playerVs.User2Name : playerVs.User3Name) || "" } disabled />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-4">Handicap</label>
                                    <div className="col-lg-6">
                                        <input type="text" className="form-control" value={(type==="Singles" ? playerVs.User2Handicap : playerVs.User3Handicap) ?? "" } readOnly />
                                    </div>
                                </div>
                                {type === "Doubles" && (
                                <>
                                    <hr />
                                    <div className="form-group row" style={{ marginTop: "1rem" }}>
                                        <label className="col-form-label col-lg-4">Player 2 <span className="text-danger">*</span></label>
                                        <div className="col-lg-6">
                                            <input type="text" className="form-control" value={playerVs.User4Name || "" } disabled />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-4">Handicap</label>
                                        <div className="col-lg-6">
                                            <input type="text" className="form-control" value={playerVs.User4Handicap ?? "" } readOnly />
                                        </div>
                                    </div>
                                </>
                                )}
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-4">Walkover Received</label>
                                    <div className="col-lg-6 d-flex align-items-center" style={{ minHeight: 38 }}>
                                        <span className="kt-switch kt-switch--icon">
                                            <label>
                                                <input type="checkbox" checked={walkoverSide==="RHS" } disabled={isVerified} onChange={e=> onWalkoverChange("RHS", e.target.checked)}
                                                />
                                                <span />
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Footer */}
                    <div className="modal-footer">
                        {!isVerified && (
                        <button type="button" className="btn btn-brand" onClick={onUpdateScore}>
                            Update Score
                        </button>
                        )}
                        {isSubmitted && !isVerified && (
                        <button type="button" className="btn btn-success margin-l10" onClick={onVerifyScore}>
                            Verify Score
                        </button>
                        )}
                        <button type="button" className="btn btn-secondary margin-l10" onClick={onClose}>
                            Cancel
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </>
    )
}
    
export default ScorecardModal;